/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CommentResultDto } from '../models';
// @ts-ignore
import type { ExamQuestionItemDto } from '../models';
// @ts-ignore
import type { ExamSubquestionItemDto } from '../models';
// @ts-ignore
import type { IndividualExamCancelResultDto } from '../models';
// @ts-ignore
import type { IndividualExamDetailDto } from '../models';
// @ts-ignore
import type { IndividualExamFinishResultDto } from '../models';
// @ts-ignore
import type { IndividualExamStartResultDto } from '../models';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ReportShareInfoDto } from '../models';
// @ts-ignore
import type { SetSubquestionScoreRequestDto } from '../models';
// @ts-ignore
import type { SetVerdictRequestDto } from '../models';
// @ts-ignore
import type { UpdateCommentRequestDto } from '../models';
// @ts-ignore
import type { VerdictResultDto } from '../models';
/**
 * IndividualExamApi - axios parameter creator
 * @export
 */
export const IndividualExamApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Cancels the exam. Exam must be DRAFT or STARTED. 
         * @summary Cancel individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelIndividualExam: async (certificationId: number, stageId: number, examId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('cancelIndividualExam', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('cancelIndividualExam', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('cancelIndividualExam', 'examId', examId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/cancel`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Zamyka obszar (== pytanie w nowym modelu). Po zamknięciu edycja ocen podpytań jest zablokowana. Wymaga: wszystkie punktowane podpytania mają przypisany score; exam jest STARTED. Również finalizuje wyliczenie passedByThreshold dla tego obszaru. 
         * @summary Close exam area (lock subquestion scoring)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeExamArea: async (certificationId: number, stageId: number, examId: string, questionResultId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('closeExamArea', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('closeExamArea', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('closeExamArea', 'examId', examId)
            // verify required parameter 'questionResultId' is not null or undefined
            assertParamExists('closeExamArea', 'questionResultId', questionResultId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/question-results/{questionResultId}/close`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"questionResultId"}}`, encodeURIComponent(String(questionResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Finishes the exam and calculates results. Exam must be STARTED. 
         * @summary Finish individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishIndividualExam: async (certificationId: number, stageId: number, examId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('finishIndividualExam', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('finishIndividualExam', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('finishIndividualExam', 'examId', examId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/finish`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns full exam data including questions, verdicts, comments, and changelog. 
         * @summary Get individual exam detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualExamDetail: async (certificationId: number, stageId: number, examId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('getIndividualExamDetail', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('getIndividualExamDetail', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('getIndividualExamDetail', 'examId', examId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Otwiera ponownie zamknięty obszar. Operacja administracyjna — wymaga uprawnień przewodniczącego/HRBP. 
         * @summary Reopen exam area (unlock subquestion scoring)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenExamArea: async (certificationId: number, stageId: number, examId: string, questionResultId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('reopenExamArea', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('reopenExamArea', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('reopenExamArea', 'examId', examId)
            // verify required parameter 'questionResultId' is not null or undefined
            assertParamExists('reopenExamArea', 'questionResultId', questionResultId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/question-results/{questionResultId}/reopen`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"questionResultId"}}`, encodeURIComponent(String(questionResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the verdict for a question. Only allowed when exam is STARTED. Verdicts are locked after exam is finished. 
         * @summary Set question verdict
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionId 
         * @param {SetVerdictRequestDto} setVerdictRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExamQuestionVerdict: async (certificationId: number, stageId: number, examId: string, questionId: number, setVerdictRequestDto: SetVerdictRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('setExamQuestionVerdict', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('setExamQuestionVerdict', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('setExamQuestionVerdict', 'examId', examId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('setExamQuestionVerdict', 'questionId', questionId)
            // verify required parameter 'setVerdictRequestDto' is not null or undefined
            assertParamExists('setExamQuestionVerdict', 'setVerdictRequestDto', setVerdictRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/questions/{questionId}/verdict`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setVerdictRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Ustawia punktację 0/1/2 dla podpytania (== podkategorii) w obrębie zamykalnego obszaru. Dozwolone tylko gdy obszar (parent question result) jest otwarty (closed=false) i exam jest STARTED. `score=null` czyści ocenę. 
         * @summary Set subquestion score (0/1/2)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {SetSubquestionScoreRequestDto} setSubquestionScoreRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExamSubquestionScore: async (certificationId: number, stageId: number, examId: string, subquestionResultId: number, setSubquestionScoreRequestDto: SetSubquestionScoreRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('setExamSubquestionScore', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('setExamSubquestionScore', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('setExamSubquestionScore', 'examId', examId)
            // verify required parameter 'subquestionResultId' is not null or undefined
            assertParamExists('setExamSubquestionScore', 'subquestionResultId', subquestionResultId)
            // verify required parameter 'setSubquestionScoreRequestDto' is not null or undefined
            assertParamExists('setExamSubquestionScore', 'setSubquestionScoreRequestDto', setSubquestionScoreRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/subquestions/{subquestionResultId}/score`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"subquestionResultId"}}`, encodeURIComponent(String(subquestionResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setSubquestionScoreRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sets the verdict for a single report subquestion. Only allowed when exam is STARTED. Parent report verdict is recomputed automatically. 
         * @summary Set subquestion verdict
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {SetVerdictRequestDto} setVerdictRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExamSubquestionVerdict: async (certificationId: number, stageId: number, examId: string, subquestionResultId: number, setVerdictRequestDto: SetVerdictRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('setExamSubquestionVerdict', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('setExamSubquestionVerdict', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('setExamSubquestionVerdict', 'examId', examId)
            // verify required parameter 'subquestionResultId' is not null or undefined
            assertParamExists('setExamSubquestionVerdict', 'subquestionResultId', subquestionResultId)
            // verify required parameter 'setVerdictRequestDto' is not null or undefined
            assertParamExists('setExamSubquestionVerdict', 'setVerdictRequestDto', setVerdictRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/subquestions/{subquestionResultId}/verdict`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"subquestionResultId"}}`, encodeURIComponent(String(subquestionResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setVerdictRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Shares a practical exam report (with subquestions and attachments) with the examinee for this individual exam. Idempotent — calling on an already-shared report is a no-op. Allowed only when exam is STARTED. 
         * @summary Share report with examinee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareExamReport: async (certificationId: number, stageId: number, examId: string, reportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('shareExamReport', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('shareExamReport', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('shareExamReport', 'examId', examId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('shareExamReport', 'reportId', reportId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/reports/{reportId}/share`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Starts the exam. Exam must be DRAFT. Exam day must be IN_PROGRESS. 
         * @summary Start individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startIndividualExam: async (certificationId: number, stageId: number, examId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('startIndividualExam', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('startIndividualExam', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('startIndividualExam', 'examId', examId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/start`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Revokes a previously shared report from the examinee for this individual exam. Idempotent — calling on a non-shared report is a no-op. Allowed only when exam is STARTED. 
         * @summary Unshare report from examinee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unshareExamReport: async (certificationId: number, stageId: number, examId: string, reportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('unshareExamReport', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('unshareExamReport', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('unshareExamReport', 'examId', examId)
            // verify required parameter 'reportId' is not null or undefined
            assertParamExists('unshareExamReport', 'reportId', reportId)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/reports/{reportId}/share`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"reportId"}}`, encodeURIComponent(String(reportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates general commission comment for the entire exam. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update general exam comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamGeneralComment: async (certificationId: number, stageId: number, examId: string, updateCommentRequestDto: UpdateCommentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateExamGeneralComment', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('updateExamGeneralComment', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('updateExamGeneralComment', 'examId', examId)
            // verify required parameter 'updateCommentRequestDto' is not null or undefined
            assertParamExists('updateExamGeneralComment', 'updateCommentRequestDto', updateCommentRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/general-comment`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates commission comment for a question. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update question comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamQuestionComment: async (certificationId: number, stageId: number, examId: string, questionId: number, updateCommentRequestDto: UpdateCommentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateExamQuestionComment', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('updateExamQuestionComment', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('updateExamQuestionComment', 'examId', examId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('updateExamQuestionComment', 'questionId', questionId)
            // verify required parameter 'updateCommentRequestDto' is not null or undefined
            assertParamExists('updateExamQuestionComment', 'updateCommentRequestDto', updateCommentRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/questions/{questionId}/comment`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"questionId"}}`, encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Updates commission comment for a single report subquestion. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update subquestion comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamSubquestionComment: async (certificationId: number, stageId: number, examId: string, subquestionResultId: number, updateCommentRequestDto: UpdateCommentRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'certificationId' is not null or undefined
            assertParamExists('updateExamSubquestionComment', 'certificationId', certificationId)
            // verify required parameter 'stageId' is not null or undefined
            assertParamExists('updateExamSubquestionComment', 'stageId', stageId)
            // verify required parameter 'examId' is not null or undefined
            assertParamExists('updateExamSubquestionComment', 'examId', examId)
            // verify required parameter 'subquestionResultId' is not null or undefined
            assertParamExists('updateExamSubquestionComment', 'subquestionResultId', subquestionResultId)
            // verify required parameter 'updateCommentRequestDto' is not null or undefined
            assertParamExists('updateExamSubquestionComment', 'updateCommentRequestDto', updateCommentRequestDto)
            const localVarPath = `/api/v2/certifications/{certificationId}/stages/{stageId}/exam/exams/{examId}/subquestions/{subquestionResultId}/comment`
                .replace(`{${"certificationId"}}`, encodeURIComponent(String(certificationId)))
                .replace(`{${"stageId"}}`, encodeURIComponent(String(stageId)))
                .replace(`{${"examId"}}`, encodeURIComponent(String(examId)))
                .replace(`{${"subquestionResultId"}}`, encodeURIComponent(String(subquestionResultId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCommentRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * IndividualExamApi - functional programming interface
 * @export
 */
export const IndividualExamApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = IndividualExamApiAxiosParamCreator(configuration)
    return {
        /**
         * Cancels the exam. Exam must be DRAFT or STARTED. 
         * @summary Cancel individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cancelIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualExamCancelResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cancelIndividualExam(certificationId, stageId, examId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.cancelIndividualExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Zamyka obszar (== pytanie w nowym modelu). Po zamknięciu edycja ocen podpytań jest zablokowana. Wymaga: wszystkie punktowane podpytania mają przypisany score; exam jest STARTED. Również finalizuje wyliczenie passedByThreshold dla tego obszaru. 
         * @summary Close exam area (lock subquestion scoring)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async closeExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamQuestionItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.closeExamArea(certificationId, stageId, examId, questionResultId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.closeExamArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Finishes the exam and calculates results. Exam must be STARTED. 
         * @summary Finish individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async finishIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualExamFinishResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.finishIndividualExam(certificationId, stageId, examId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.finishIndividualExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns full exam data including questions, verdicts, comments, and changelog. 
         * @summary Get individual exam detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getIndividualExamDetail(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualExamDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getIndividualExamDetail(certificationId, stageId, examId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.getIndividualExamDetail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Otwiera ponownie zamknięty obszar. Operacja administracyjna — wymaga uprawnień przewodniczącego/HRBP. 
         * @summary Reopen exam area (unlock subquestion scoring)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reopenExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamQuestionItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reopenExamArea(certificationId, stageId, examId, questionResultId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.reopenExamArea']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets the verdict for a question. Only allowed when exam is STARTED. Verdicts are locked after exam is finished. 
         * @summary Set question verdict
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionId 
         * @param {SetVerdictRequestDto} setVerdictRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExamQuestionVerdict(certificationId: number, stageId: number, examId: string, questionId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerdictResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExamQuestionVerdict(certificationId, stageId, examId, questionId, setVerdictRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.setExamQuestionVerdict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Ustawia punktację 0/1/2 dla podpytania (== podkategorii) w obrębie zamykalnego obszaru. Dozwolone tylko gdy obszar (parent question result) jest otwarty (closed=false) i exam jest STARTED. `score=null` czyści ocenę. 
         * @summary Set subquestion score (0/1/2)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {SetSubquestionScoreRequestDto} setSubquestionScoreRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExamSubquestionScore(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setSubquestionScoreRequestDto: SetSubquestionScoreRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ExamSubquestionItemDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExamSubquestionScore(certificationId, stageId, examId, subquestionResultId, setSubquestionScoreRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.setExamSubquestionScore']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sets the verdict for a single report subquestion. Only allowed when exam is STARTED. Parent report verdict is recomputed automatically. 
         * @summary Set subquestion verdict
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {SetVerdictRequestDto} setVerdictRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setExamSubquestionVerdict(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<VerdictResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setExamSubquestionVerdict(certificationId, stageId, examId, subquestionResultId, setVerdictRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.setExamSubquestionVerdict']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Shares a practical exam report (with subquestions and attachments) with the examinee for this individual exam. Idempotent — calling on an already-shared report is a no-op. Allowed only when exam is STARTED. 
         * @summary Share report with examinee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async shareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportShareInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.shareExamReport(certificationId, stageId, examId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.shareExamReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Starts the exam. Exam must be DRAFT. Exam day must be IN_PROGRESS. 
         * @summary Start individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async startIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<IndividualExamStartResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.startIndividualExam(certificationId, stageId, examId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.startIndividualExam']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Revokes a previously shared report from the examinee for this individual exam. Idempotent — calling on a non-shared report is a no-op. Allowed only when exam is STARTED. 
         * @summary Unshare report from examinee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unshareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ReportShareInfoDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unshareExamReport(certificationId, stageId, examId, reportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.unshareExamReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates general commission comment for the entire exam. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update general exam comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExamGeneralComment(certificationId: number, stageId: number, examId: string, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExamGeneralComment(certificationId, stageId, examId, updateCommentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.updateExamGeneralComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates commission comment for a question. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update question comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExamQuestionComment(certificationId: number, stageId: number, examId: string, questionId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExamQuestionComment(certificationId, stageId, examId, questionId, updateCommentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.updateExamQuestionComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Updates commission comment for a single report subquestion. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update subquestion comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateExamSubquestionComment(certificationId: number, stageId: number, examId: string, subquestionResultId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommentResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateExamSubquestionComment(certificationId, stageId, examId, subquestionResultId, updateCommentRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['IndividualExamApi.updateExamSubquestionComment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * IndividualExamApi - factory interface
 * @export
 */
export const IndividualExamApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = IndividualExamApiFp(configuration)
    return {
        /**
         * Cancels the exam. Exam must be DRAFT or STARTED. 
         * @summary Cancel individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cancelIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamCancelResultDto> {
            return localVarFp.cancelIndividualExam(certificationId, stageId, examId, options).then((request) => request(axios, basePath));
        },
        /**
         * Zamyka obszar (== pytanie w nowym modelu). Po zamknięciu edycja ocen podpytań jest zablokowana. Wymaga: wszystkie punktowane podpytania mają przypisany score; exam jest STARTED. Również finalizuje wyliczenie passedByThreshold dla tego obszaru. 
         * @summary Close exam area (lock subquestion scoring)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        closeExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamQuestionItemDto> {
            return localVarFp.closeExamArea(certificationId, stageId, examId, questionResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * Finishes the exam and calculates results. Exam must be STARTED. 
         * @summary Finish individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        finishIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamFinishResultDto> {
            return localVarFp.finishIndividualExam(certificationId, stageId, examId, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns full exam data including questions, verdicts, comments, and changelog. 
         * @summary Get individual exam detail
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getIndividualExamDetail(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamDetailDto> {
            return localVarFp.getIndividualExamDetail(certificationId, stageId, examId, options).then((request) => request(axios, basePath));
        },
        /**
         * Otwiera ponownie zamknięty obszar. Operacja administracyjna — wymaga uprawnień przewodniczącego/HRBP. 
         * @summary Reopen exam area (unlock subquestion scoring)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionResultId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reopenExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamQuestionItemDto> {
            return localVarFp.reopenExamArea(certificationId, stageId, examId, questionResultId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the verdict for a question. Only allowed when exam is STARTED. Verdicts are locked after exam is finished. 
         * @summary Set question verdict
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionId 
         * @param {SetVerdictRequestDto} setVerdictRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExamQuestionVerdict(certificationId: number, stageId: number, examId: string, questionId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VerdictResultDto> {
            return localVarFp.setExamQuestionVerdict(certificationId, stageId, examId, questionId, setVerdictRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Ustawia punktację 0/1/2 dla podpytania (== podkategorii) w obrębie zamykalnego obszaru. Dozwolone tylko gdy obszar (parent question result) jest otwarty (closed=false) i exam jest STARTED. `score=null` czyści ocenę. 
         * @summary Set subquestion score (0/1/2)
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {SetSubquestionScoreRequestDto} setSubquestionScoreRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExamSubquestionScore(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setSubquestionScoreRequestDto: SetSubquestionScoreRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamSubquestionItemDto> {
            return localVarFp.setExamSubquestionScore(certificationId, stageId, examId, subquestionResultId, setSubquestionScoreRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Sets the verdict for a single report subquestion. Only allowed when exam is STARTED. Parent report verdict is recomputed automatically. 
         * @summary Set subquestion verdict
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {SetVerdictRequestDto} setVerdictRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setExamSubquestionVerdict(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VerdictResultDto> {
            return localVarFp.setExamSubquestionVerdict(certificationId, stageId, examId, subquestionResultId, setVerdictRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Shares a practical exam report (with subquestions and attachments) with the examinee for this individual exam. Idempotent — calling on an already-shared report is a no-op. Allowed only when exam is STARTED. 
         * @summary Share report with examinee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        shareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<ReportShareInfoDto> {
            return localVarFp.shareExamReport(certificationId, stageId, examId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Starts the exam. Exam must be DRAFT. Exam day must be IN_PROGRESS. 
         * @summary Start individual exam
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        startIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamStartResultDto> {
            return localVarFp.startIndividualExam(certificationId, stageId, examId, options).then((request) => request(axios, basePath));
        },
        /**
         * Revokes a previously shared report from the examinee for this individual exam. Idempotent — calling on a non-shared report is a no-op. Allowed only when exam is STARTED. 
         * @summary Unshare report from examinee
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} reportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unshareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<ReportShareInfoDto> {
            return localVarFp.unshareExamReport(certificationId, stageId, examId, reportId, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates general commission comment for the entire exam. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update general exam comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamGeneralComment(certificationId: number, stageId: number, examId: string, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentResultDto> {
            return localVarFp.updateExamGeneralComment(certificationId, stageId, examId, updateCommentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates commission comment for a question. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update question comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} questionId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamQuestionComment(certificationId: number, stageId: number, examId: string, questionId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentResultDto> {
            return localVarFp.updateExamQuestionComment(certificationId, stageId, examId, questionId, updateCommentRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Updates commission comment for a single report subquestion. Allowed when exam is STARTED, PASSED, or FAILED. 
         * @summary Update subquestion comment
         * @param {number} certificationId 
         * @param {number} stageId 
         * @param {string} examId 
         * @param {number} subquestionResultId 
         * @param {UpdateCommentRequestDto} updateCommentRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateExamSubquestionComment(certificationId: number, stageId: number, examId: string, subquestionResultId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentResultDto> {
            return localVarFp.updateExamSubquestionComment(certificationId, stageId, examId, subquestionResultId, updateCommentRequestDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * IndividualExamApi - interface
 * @export
 * @interface IndividualExamApi
 */
export interface IndividualExamApiInterface {
    /**
     * Cancels the exam. Exam must be DRAFT or STARTED. 
     * @summary Cancel individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    cancelIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamCancelResultDto>;

    /**
     * Zamyka obszar (== pytanie w nowym modelu). Po zamknięciu edycja ocen podpytań jest zablokowana. Wymaga: wszystkie punktowane podpytania mają przypisany score; exam jest STARTED. Również finalizuje wyliczenie passedByThreshold dla tego obszaru. 
     * @summary Close exam area (lock subquestion scoring)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    closeExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamQuestionItemDto>;

    /**
     * Finishes the exam and calculates results. Exam must be STARTED. 
     * @summary Finish individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    finishIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamFinishResultDto>;

    /**
     * Returns full exam data including questions, verdicts, comments, and changelog. 
     * @summary Get individual exam detail
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    getIndividualExamDetail(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamDetailDto>;

    /**
     * Otwiera ponownie zamknięty obszar. Operacja administracyjna — wymaga uprawnień przewodniczącego/HRBP. 
     * @summary Reopen exam area (unlock subquestion scoring)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    reopenExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig): AxiosPromise<ExamQuestionItemDto>;

    /**
     * Sets the verdict for a question. Only allowed when exam is STARTED. Verdicts are locked after exam is finished. 
     * @summary Set question verdict
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionId 
     * @param {SetVerdictRequestDto} setVerdictRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    setExamQuestionVerdict(certificationId: number, stageId: number, examId: string, questionId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VerdictResultDto>;

    /**
     * Ustawia punktację 0/1/2 dla podpytania (== podkategorii) w obrębie zamykalnego obszaru. Dozwolone tylko gdy obszar (parent question result) jest otwarty (closed=false) i exam jest STARTED. `score=null` czyści ocenę. 
     * @summary Set subquestion score (0/1/2)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} subquestionResultId 
     * @param {SetSubquestionScoreRequestDto} setSubquestionScoreRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    setExamSubquestionScore(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setSubquestionScoreRequestDto: SetSubquestionScoreRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ExamSubquestionItemDto>;

    /**
     * Sets the verdict for a single report subquestion. Only allowed when exam is STARTED. Parent report verdict is recomputed automatically. 
     * @summary Set subquestion verdict
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} subquestionResultId 
     * @param {SetVerdictRequestDto} setVerdictRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    setExamSubquestionVerdict(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<VerdictResultDto>;

    /**
     * Shares a practical exam report (with subquestions and attachments) with the examinee for this individual exam. Idempotent — calling on an already-shared report is a no-op. Allowed only when exam is STARTED. 
     * @summary Share report with examinee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    shareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<ReportShareInfoDto>;

    /**
     * Starts the exam. Exam must be DRAFT. Exam day must be IN_PROGRESS. 
     * @summary Start individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    startIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig): AxiosPromise<IndividualExamStartResultDto>;

    /**
     * Revokes a previously shared report from the examinee for this individual exam. Idempotent — calling on a non-shared report is a no-op. Allowed only when exam is STARTED. 
     * @summary Unshare report from examinee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    unshareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig): AxiosPromise<ReportShareInfoDto>;

    /**
     * Updates general commission comment for the entire exam. Allowed when exam is STARTED, PASSED, or FAILED. 
     * @summary Update general exam comment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {UpdateCommentRequestDto} updateCommentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    updateExamGeneralComment(certificationId: number, stageId: number, examId: string, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentResultDto>;

    /**
     * Updates commission comment for a question. Allowed when exam is STARTED, PASSED, or FAILED. 
     * @summary Update question comment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionId 
     * @param {UpdateCommentRequestDto} updateCommentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    updateExamQuestionComment(certificationId: number, stageId: number, examId: string, questionId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentResultDto>;

    /**
     * Updates commission comment for a single report subquestion. Allowed when exam is STARTED, PASSED, or FAILED. 
     * @summary Update subquestion comment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} subquestionResultId 
     * @param {UpdateCommentRequestDto} updateCommentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApiInterface
     */
    updateExamSubquestionComment(certificationId: number, stageId: number, examId: string, subquestionResultId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<CommentResultDto>;

}

/**
 * IndividualExamApi - object-oriented interface
 * @export
 * @class IndividualExamApi
 * @extends {BaseAPI}
 */
export class IndividualExamApi extends BaseAPI implements IndividualExamApiInterface {
    /**
     * Cancels the exam. Exam must be DRAFT or STARTED. 
     * @summary Cancel individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public cancelIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).cancelIndividualExam(certificationId, stageId, examId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Zamyka obszar (== pytanie w nowym modelu). Po zamknięciu edycja ocen podpytań jest zablokowana. Wymaga: wszystkie punktowane podpytania mają przypisany score; exam jest STARTED. Również finalizuje wyliczenie passedByThreshold dla tego obszaru. 
     * @summary Close exam area (lock subquestion scoring)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public closeExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).closeExamArea(certificationId, stageId, examId, questionResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Finishes the exam and calculates results. Exam must be STARTED. 
     * @summary Finish individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public finishIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).finishIndividualExam(certificationId, stageId, examId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns full exam data including questions, verdicts, comments, and changelog. 
     * @summary Get individual exam detail
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public getIndividualExamDetail(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).getIndividualExamDetail(certificationId, stageId, examId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Otwiera ponownie zamknięty obszar. Operacja administracyjna — wymaga uprawnień przewodniczącego/HRBP. 
     * @summary Reopen exam area (unlock subquestion scoring)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionResultId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public reopenExamArea(certificationId: number, stageId: number, examId: string, questionResultId: number, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).reopenExamArea(certificationId, stageId, examId, questionResultId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the verdict for a question. Only allowed when exam is STARTED. Verdicts are locked after exam is finished. 
     * @summary Set question verdict
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionId 
     * @param {SetVerdictRequestDto} setVerdictRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public setExamQuestionVerdict(certificationId: number, stageId: number, examId: string, questionId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).setExamQuestionVerdict(certificationId, stageId, examId, questionId, setVerdictRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Ustawia punktację 0/1/2 dla podpytania (== podkategorii) w obrębie zamykalnego obszaru. Dozwolone tylko gdy obszar (parent question result) jest otwarty (closed=false) i exam jest STARTED. `score=null` czyści ocenę. 
     * @summary Set subquestion score (0/1/2)
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} subquestionResultId 
     * @param {SetSubquestionScoreRequestDto} setSubquestionScoreRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public setExamSubquestionScore(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setSubquestionScoreRequestDto: SetSubquestionScoreRequestDto, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).setExamSubquestionScore(certificationId, stageId, examId, subquestionResultId, setSubquestionScoreRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sets the verdict for a single report subquestion. Only allowed when exam is STARTED. Parent report verdict is recomputed automatically. 
     * @summary Set subquestion verdict
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} subquestionResultId 
     * @param {SetVerdictRequestDto} setVerdictRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public setExamSubquestionVerdict(certificationId: number, stageId: number, examId: string, subquestionResultId: number, setVerdictRequestDto: SetVerdictRequestDto, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).setExamSubquestionVerdict(certificationId, stageId, examId, subquestionResultId, setVerdictRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Shares a practical exam report (with subquestions and attachments) with the examinee for this individual exam. Idempotent — calling on an already-shared report is a no-op. Allowed only when exam is STARTED. 
     * @summary Share report with examinee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public shareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).shareExamReport(certificationId, stageId, examId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Starts the exam. Exam must be DRAFT. Exam day must be IN_PROGRESS. 
     * @summary Start individual exam
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public startIndividualExam(certificationId: number, stageId: number, examId: string, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).startIndividualExam(certificationId, stageId, examId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Revokes a previously shared report from the examinee for this individual exam. Idempotent — calling on a non-shared report is a no-op. Allowed only when exam is STARTED. 
     * @summary Unshare report from examinee
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} reportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public unshareExamReport(certificationId: number, stageId: number, examId: string, reportId: number, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).unshareExamReport(certificationId, stageId, examId, reportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates general commission comment for the entire exam. Allowed when exam is STARTED, PASSED, or FAILED. 
     * @summary Update general exam comment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {UpdateCommentRequestDto} updateCommentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public updateExamGeneralComment(certificationId: number, stageId: number, examId: string, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).updateExamGeneralComment(certificationId, stageId, examId, updateCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates commission comment for a question. Allowed when exam is STARTED, PASSED, or FAILED. 
     * @summary Update question comment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} questionId 
     * @param {UpdateCommentRequestDto} updateCommentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public updateExamQuestionComment(certificationId: number, stageId: number, examId: string, questionId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).updateExamQuestionComment(certificationId, stageId, examId, questionId, updateCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Updates commission comment for a single report subquestion. Allowed when exam is STARTED, PASSED, or FAILED. 
     * @summary Update subquestion comment
     * @param {number} certificationId 
     * @param {number} stageId 
     * @param {string} examId 
     * @param {number} subquestionResultId 
     * @param {UpdateCommentRequestDto} updateCommentRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof IndividualExamApi
     */
    public updateExamSubquestionComment(certificationId: number, stageId: number, examId: string, subquestionResultId: number, updateCommentRequestDto: UpdateCommentRequestDto, options?: RawAxiosRequestConfig) {
        return IndividualExamApiFp(this.configuration).updateExamSubquestionComment(certificationId, stageId, examId, subquestionResultId, updateCommentRequestDto, options).then((request) => request(this.axios, this.basePath));
    }
}

